<template>
  <div style="align-items: center;">
    <div id="map" style="height: 500px; width: 80%; border-radius: 5px; margin: auto;"></div>
  </div>
</template>

<script>
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

export default {
  name: 'MapComponent',
  data() {
    return {
      map: null,
      markers: []
    }
  },
  computed: {
    associations() {
      return this.$store.getters.getAssociations
    }
  },
  watch: {
    associations(newAssos) {
      if (newAssos.length > 0 && this.map) {
        this.addMarkers(newAssos)
      }
    }
  },
  mounted() {
    // Corrige les icônes par défaut de Leaflet
    delete L.Icon.Default.prototype._getIconUrl
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: new URL('leaflet/dist/images/marker-icon-2x.png', import.meta.url).href,
      iconUrl: new URL('leaflet/dist/images/marker-icon.png', import.meta.url).href,
      shadowUrl: new URL('leaflet/dist/images/marker-shadow.png', import.meta.url).href,
    })

    // Initialise la carte
    this.map = L.map('map').setView([50.6333, 5.5667], 13)

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors'
    }).addTo(this.map)

    // Charge les associations si pas encore dispo
    if (this.associations.length === 0) {
      this.$store.dispatch('loadAssociations')
    } else {
      this.addMarkers(this.associations)
    }
  },
  methods: {
    addMarkers(associations) {
      // Supprime les anciens marqueurs
      this.markers.forEach(marker => this.map.removeLayer(marker))
      this.markers = []

      // Ajoute les nouveaux
      associations.forEach(asso => {
        if (asso.latitude && asso.longitude) {
          const marker = L.marker([asso.latitude, asso.longitude])
            .addTo(this.map)
            .bindPopup(`<strong>${asso.name}</strong><br>${asso.description || ''}`)
          this.markers.push(marker)
        }
      })
    }
  }
}
</script>

<style scoped>
#map {
  z-index: 0;
}
</style>
